import { AgeType } from 'common/dto-types/team-dto';

const AgeTypeCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case AgeType.Olympic:
            return <p>Olympic</p>;
        case AgeType.YouthOlympic:
            return <p>Youth Olympic</p>;
        case AgeType.Main:
            return <p>Main</p>;
        case AgeType.Under13:
            return <p>U-13</p>;
        case AgeType.Under14:
            return <p>U-14</p>;
        case AgeType.Under15:
            return <p>U-15</p>;
        case AgeType.Under16:
            return <p>U-16</p>;
        case AgeType.Under17:
            return <p>U-17</p>;
        case AgeType.Under18:
            return <p>U-18</p>;
        case AgeType.Under19:
            return <p>U-19</p>;
        case AgeType.Under20:
            return <p>U-20</p>;
        case AgeType.Under21:
            return <p>U-21</p>;
        case AgeType.Under22:
            return <p>U-22</p>;
        case AgeType.Under23:
            return <p>U-23</p>;
        case AgeType.Unknown:
        default:
            return <p>Unknown</p>;
    }
};

export default AgeTypeCell;
